import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { analyticsApi, type KPIValue } from '../../api/analytics';

export function KPIManagerPage() {
  const [kpis, setKpis] = useState<KPIValue[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void analyticsApi.biKPIs().then((r) => setKpis(r.kpis ?? [])).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">KPI Manager</h1>
        <Link to="/analytics/bi" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← BI Hub</Link>
      </div>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Configurable KPI framework with formula builder and derived metrics.</p>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 space-y-2">
        {kpis.map((k) => (
          <div key={k.key} className="flex items-center justify-between rounded-lg border p-4 dark:border-slate-700">
            <div>
              <p className="font-medium">{k.name}</p>
              <p className="text-xs text-slate-500">{k.domain} · {k.key}</p>
            </div>
            <div className="text-right">
              <p className="text-lg font-semibold">{k.unit === '%' ? `${k.value.toFixed(1)}%` : k.value.toLocaleString()}</p>
              {k.change !== undefined && <p className={`text-xs ${k.change >= 0 ? 'text-green-600' : 'text-red-600'}`}>{k.change >= 0 ? '+' : ''}{k.change.toFixed(1)}%</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
